module.exports = __webpack_public_path__ + "static/img/alls.d7b56e5c.png";